import styled from 'styled-components';
import Image from 'next/image';
import Slider from "react-slick";
import IC_LEFT_WHITE from '/public/images/ic_left_white.svg';
import IC_RIGHT_WHITE from '/public/images/ic_right_white.svg';

// Styled components
const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    cursor: grab;
    :active {
        cursor: grabbing;
    }
`;

const ControlWrapper = styled.div`
    user-select: none;
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    z-index: 9999;
`;

const DownloadButton = styled.div`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    font-size: 34px;
    line-height: 34px;
    cursor: pointer;
    color: #fff;
`;

const CloseButton = styled.button`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    cursor: pointer;
    color: #fff;
    background: transparent;
    border: none;
    font-size: 24px;
`;

const SlideCounter = styled.div`
    user-select: none;
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    position: absolute;
    top: 20px;
    left: 20px;
    color: #fff;
    z-index: 9999;
`;

const NavigationWrapper = styled.div`
    user-select: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    z-index: 9999;
`;

const NavigationButton = styled.div`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 20px;
    transform: ${(props) => (props.flip ? 'scaleX(-1)' : 'none')};
`;

// Your component
export function PhotoSlider({ isOpen, setIsOpen, currentIndex, photos, setCurrentIndex }) {
    let slider;

    const handleDownload = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute('download', url.split("/").pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const settings = {
        initialSlide: currentIndex,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (current) => setCurrentIndex(current),
        arrows: false,
    };

    return (
        <>
            {isOpen && (
                <Overlay>
                    <ControlWrapper>
                        <DownloadButton onClick={() => handleDownload(photos[currentIndex]?.url)}>
                            ⤓
                        </DownloadButton>
                        <CloseButton onClick={handleClose}>✖</CloseButton>
                    </ControlWrapper>

                    <SlideCounter>
                        {currentIndex + 1} / {photos.length}
                    </SlideCounter>

                    <NavigationWrapper>
                        <NavigationButton onClick={() => slider.slickPrev()}>
                            <Image src={IC_LEFT_WHITE} alt={'<'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                        </NavigationButton>
                        <NavigationButton onClick={() => slider.slickNext()}>
                            <Image src={IC_RIGHT_WHITE} alt={'>'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                        </NavigationButton>
                    </NavigationWrapper>

                    <Slider ref={c => (slider = c)} {...settings}>
                        {photos.map((photo, index) => (
                            <div key={index} style={{margin:'50px'}}>
                                <div style={{
                                    width:'100%',
                                    height:'100vh',
                                    display:'flex',
                                    justifyContent:'center',
                                    alignItems:'center',
                                }}>
                                    <Image
                                        src={photo.url}
                                        alt={photo.alt ?? photo.name}
                                        width={1500}
                                        height={1500}
                                        style={{ width: '99vw', height: '50vh',minHeight:'500px', objectFit: 'contain', objectPosition:'center'}}
                                    />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </Overlay>
            )}
        </>
    );
}
